<div
  class="fade modal-lg modal"
  id="foodFormModal"
  tabindex="-1"
  aria-labelledby="exerciseFormModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1
          class="modal-title fs-5"
          id="exerciseFormModalLabel"
          *ngIf="editing"
        >
          Edición de una comida
        </h1>
        <h1
          class="modal-title fs-5"
          id="exerciseFormModalLabel"
          *ngIf="!editing"
        >
          Creación de una comida
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="clearAllFields()"
        ></button>
      </div>

      <div class="modal-body">
        <form [formGroup]="foodForm" class="row">
          <span class="fw-bold fs-4 m-2 mt-4">DATOS OBLIGATORIOS</span>

          <div class="form-floating mb-3 ml-auto gx-1">
            <input
              class="form-control"
              type="text"
              [ngClass]="{ 'is-invalid': name.invalid && name.touched }"
              placeholder="Título"
              formControlName="name"
            />

            <label for="">Nombre</label>

            <div *ngIf="name.invalid && name.touched" class="text-danger">
              Ingrese un nombre válido
            </div>
          </div>

          <div class="form-floating col-6 ml-auto gx-1 mb-3 ml-auto gx-1">
            <select
              class="form-select"
              id="floatingSelect"
              formControlName="portionMeasure"
            >
              <option selected [value]="'100GR'">100gr</option>
              <option value="UNIT">Una unidad</option>
              <option value="SPOON">Una cucharada</option>
            </select>
            <label for="floatingSelect">Unidad de medida</label>
          </div>

          <div class="form-floating col-6 ml-auto gx-1 mb-3 ml-auto gx-1">
            <select
              class="form-select"
              id="floatingType"
              formControlName="type"
              [ngClass]="{ 'is-invalid': type.invalid && type.touched }"
            >
              <option value="FOOD">Comida</option>
              <option value="SUPPLEMENT">Suplemento</option>
            </select>
            <label for="floatingType">Tipo</label>
            <div *ngIf="type.invalid && type.touched" class="text-danger">
              Seleccione un tipo válido
            </div>
          </div>

          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingproteins"
              placeholder="proteins"
              formControlName="proteins"
            />
            <label for="floatingproteins">Proteínas</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingcarbohydrates"
              placeholder="carbohydrates"
              formControlName="carbohydrates"
            />
            <label for="floatingcarbohydrates">Carbohidratos</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingsaturatedFats"
              placeholder="saturatedFats"
              formControlName="saturatedFats"
            />
            <label for="floatingsaturatedFats">Grasas Saturadas</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingunsaturatedFats"
              placeholder="unsaturatedFats"
              formControlName="unsaturatedFats"
            />
            <label for="floatingunsaturatedFats">Grasas Insaturadas</label>
          </div>

          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingunsaturatedFats"
              placeholder="kcal"
              formControlName="kcal"
            />
            <label for="floatingunsaturatedFats">Kilocalorias</label>
          </div>

          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="fiber"
              placeholder="fiber"
              formControlName="fiber"
            />
            <label for="fiber">Fibra</label>
          </div>

          <span class="fw-bold fs-4 m-2 mt-4">MICRONUTRIENTES</span>

          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingvitamin_a"
              placeholder="vitamin_a"
              formControlName="vitamin_a"
            />
            <label for="floatingvitamin_a">Vitamina A</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingvitamin_c"
              placeholder="vitamin_c"
              formControlName="vitamin_c"
            />
            <label for="floatingvitamin_c">Vitamina C</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingvitamin_d"
              placeholder="vitamin_d"
              formControlName="vitamin_d"
            />
            <label for="floatingvitamin_d">Vitamina D</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingvitamin_e"
              placeholder="vitamin_e"
              formControlName="vitamin_e"
            />
            <label for="floatingvitamin_e">Vitamina E</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingvitamin_k"
              placeholder="vitamin_k"
              formControlName="vitamin_k"
            />
            <label for="floatingvitamin_k">Vitamina K</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingvitamin_b1"
              placeholder="vitamin_b1"
              formControlName="vitamin_b1"
            />
            <label for="floatingvitamin_b1">Vitamina B1</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingvitamin_b2"
              placeholder="vitamin_b2"
              formControlName="vitamin_b2"
            />
            <label for="floatingvitamin_b2">Vitamina B2</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingvitamin_b3"
              placeholder="vitamin_b3"
              formControlName="vitamin_b3"
            />
            <label for="floatingvitamin_b3">Vitamina B3</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingvitamin_b5"
              placeholder="vitamin_b5"
              formControlName="vitamin_b5"
            />
            <label for="floatingvitamin_b5">Vitamina B5</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingvitamin_b6_biotin"
              placeholder="vitamin_b6_biotin"
              formControlName="vitamin_b6_biotin"
            />
            <label for="floatingvitamin_b6_biotin">Vitamina B6 (Biotina)</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingvitamin_b6_pyridoxine"
              placeholder="vitamin_b6_pyridoxine"
              formControlName="vitamin_b6_pyridoxine"
            />
            <label for="floatingvitamin_b6_pyridoxine"
              >Vitamina B6 (Piridoxina)</label
            >
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingvitamin_b9"
              placeholder="vitamin_b9"
              formControlName="vitamin_b9"
            />
            <label for="floatingvitamin_b6_pyridoxine">Vitamina B9</label>
          </div>

          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingvitamin_b12"
              placeholder="vitamin_b12"
              formControlName="vitamin_b12"
            />
            <label for="floatingvitamin_b12">Vitamina B12</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingpotassium"
              placeholder="potassium"
              formControlName="potassium"
            />
            <label for="floatingpotassium">Potasio</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingchlorine"
              placeholder="chlorine"
              formControlName="chlorine"
            />
            <label for="floatingchlorine">Cloro</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingsodium"
              placeholder="sodium"
              formControlName="sodium"
            />
            <label for="floatingsodium">Sodio</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingcalcium"
              placeholder="calcium"
              formControlName="calcium"
            />
            <label for="floatingcalcium">Calcio</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingiron"
              placeholder="iron"
              formControlName="iron"
            />
            <label for="floatingiron">Hierro</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingphosphorus"
              placeholder="phosphorus"
              formControlName="phosphorus"
            />
            <label for="floatingphosphorus">Fósforo</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingcopper"
              placeholder="copper"
              formControlName="copper"
            />
            <label for="floatingcopper">Cobre</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingiodine"
              placeholder="iodine"
              formControlName="iodine"
            />
            <label for="floatingiodine">Yodo</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingmagnesium"
              placeholder="magnesium"
              formControlName="magnesium"
            />
            <label for="floatingmagnesium">Magnesio</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingzinc"
              placeholder="zinc"
              formControlName="zinc"
            />
            <label for="floatingzinc">Zinc</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingmanganese"
              placeholder="manganese"
              formControlName="manganese"
            />
            <label for="floatingmanganese">Manganeso</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingchromium"
              placeholder="chromium"
              formControlName="chromium"
            />
            <label for="floatingchromium">Cromo</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingmolybdenum"
              placeholder="molybdenum"
              formControlName="molybdenum"
            />
            <label for="floatingmolybdenum">Molibdeno</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingcobalt"
              placeholder="cobalt"
              formControlName="cobalt"
            />
            <label for="floatingcobalt">Cobalto</label>
          </div>
          <div class="form-floating mb-3 col-6 ml-auto gx-1">
            <input
              type="number"
              class="form-control"
              id="floatingselenium"
              placeholder="selenium"
              formControlName="selenium"
            />
            <label for="floatingselenium">Selenio</label>
          </div>

          <button
            [disabled]="foodForm.invalid"
            class="col-12 mt-2 d-grid btn-custom"
            (click)="onSubmit()"
          >
            <span *ngIf="editing">Editar</span>
            <span *ngIf="!editing">Crear</span>
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
